import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Dialog,
  DialogContent,
  Backdrop,
  Button,
  Tooltip,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import {
  CloseSharp,
  EditNoteSharp,
  RemoveRedEye,
  TryOutlined,
} from "@mui/icons-material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import recipienticon from "../../assets/images/recipient-name.png";
import recipientemailicon from "../../assets/images/email-icon-pod.png";
import deliverydateicon from "../../assets/images/delivery-date-pod.png";
import deliverytimeicon from "../../assets/images/deliverytime-pod-icon.png";
import podloc1icon from "../../assets/images/pod-location1-icon.png";
import podloc2icon from "../../assets/images/pod-loc2-icon.png";
import { formatter, toLocalTime } from "../../helper/functions";
import PodMap from "../../components/maps/PodMap";
import { $crud } from "../../utils/CrudFactory";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
    backdropFilter: "blur(2px)", // Adjust blur strength as needed
  },
  dialogPaper: {
    borderRadius: "0", // Set border radius to 0
    border: "1px solid #000",
  },
  textFieldRoot: {
    "& .MuiInputLabel-root": {
      color: "#8D8D8E !important", // Adding !important to ensure the color overrides
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "rgba(103, 60, 142, 1)", // Initial outlined border color
      },
      "&:hover fieldset": {
        borderColor: "rgba(103, 60, 142, 1)", // Change outlined border color on hover
      },
      "&.Mui-focused fieldset": {
        borderColor: "rgba(103, 60, 142, 1)", // Change outlined border color when focused
      },
    },
  },
}));
const ExtraTipModal = ({ orderId }) => {
  const classes = useStyles();
  const [tips, setTips] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    async function fetchTips() {
      try {
        const { data } = await $crud.retrieve(
          `admin/orders/${orderId}/extratips`
        );

        setTips(data.extraTips);
      } catch (e) {
        console.error(e);
      }
    }
    fetchTips();
  }, [orderId]);

  return (
    <>
      <Button
        onClick={() => setOpen(true)}
        variant="contained"
        size="small"
        sx={{
          padding: "10px",
          width: "175px",
          height: "45px",
          borderRadius: "12px",
          fontWeight: 600,
          textTransform: "capitalize",
          color: "#683C8C",
          border: "1px solid #683C8C",
          boxShadow: "none !important",
          backgroundColor: "#ffffff !important",
        }}
      >
        Total Tips ({tips.length}) -{" "}
        {tips.length > 0
          ? formatter.format(
              tips.reduce(
                (prev, curr) =>
                  prev + (Number(curr.extra_Tip) + Number(curr.tax_extra_Tip)),
                0
              )
            )
          : 0}
      </Button>
      <Backdrop className={classes.backdrop} open={open} />
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        sx={{ mx: "auto" }}
        // classes={{ paper: classes.dialogPaper }}
      >
        <DialogContent
          sx={{
            padding: "15px",
            width: "364px",
            backgroundColor: "white",
            position: "relative",
            borderRadius: "12px",
          }}
        >
          <CloseSharp
            onClick={() => setOpen(false)}
            sx={{
              width: "15px",
              height: "15px",
              color: "black",
              right: "14px",
              top: "13px",
              position: "absolute",
              cursor: "pointer",
            }}
          />

          <Box display="flex" flexDirection={"column"} gap="10px" mt="20px">
            {tips.length > 0 ? (
              tips.map((tip, i) => (
                <Box
                  key={i}
                  display="flex"
                  flexDirection={"column"}
                  gap="10px"
                  sx={{ backgroundColor: "#E5DEEC" }}
                  p="10px"
                >
                  <Box
                    display="flex"
                    alignItems={"center"}
                    justifyContent={"space-between"}
                    gap="10px"
                  >
                    <Typography
                      fontSize={"12px"}
                      color={"black"}
                      fontWeight={600}
                    >
                      Extra Tip {i + 1}
                    </Typography>
                    <Box display="flex" alignItems={"center"} gap="10px">
                      <Typography
                        fontSize={"12px"}
                        color={"black"}
                        fontWeight={600}
                      >
                        At - {tip.status}
                      </Typography>
                      <Tooltip
                        arrow
                        componentsProps={{
                          tooltip: {
                            sx: {
                              backgroundColor: "#FFFFFF",
                              p: "10px",
                              borderRadius: "12px",
                            },
                          },
                          arrow: {
                            sx: {
                              color: "#FFFFFF",
                            },
                          },
                        }}
                        title={
                          <Box
                            textAlign={"center"}
                            fontSize={"15px"}
                            color="#673C8E"
                          >
                            <Typography fontWeight={700}>
                              Extra Tip {i + 1} : At “{tip.status}”
                            </Typography>
                            <Typography>{tip.comments}</Typography>
                          </Box>
                        }
                      >
                        <RemoveRedEye sx={{ cursor: "pointer" }} />
                      </Tooltip>
                    </Box>
                  </Box>
                  <Box
                    display="flex"
                    alignItems={"center"}
                    justifyContent={"space-between"}
                    gap="10px"
                  >
                    <Typography fontSize={"12px"} color={"black"}>
                      Extra Tip
                    </Typography>
                    <Box display="flex" alignItems={"center"} gap="6px">
                      <EditOutlinedIcon
                        sx={{ width: "15px", height: "15px" }}
                      />
                      <Typography fontSize={"12px"} color={"black"}>
                        {formatter.format(tip.extra_Tip)}
                      </Typography>
                    </Box>
                  </Box>
                  <Box
                    display="flex"
                    alignItems={"center"}
                    justifyContent={"space-between"}
                    gap="10px"
                  >
                    <Typography fontSize={"12px"} color={"black"}>
                      Taxes on extra tip
                    </Typography>
                    <Box display="flex" alignItems={"center"} gap="10px">
                      <Typography fontSize={"12px"} color={"black"}>
                        {formatter.format(tip.tax_extra_Tip)}
                      </Typography>
                    </Box>
                  </Box>
                  <Box
                    display="flex"
                    alignItems={"center"}
                    justifyContent={"space-between"}
                    gap="10px"
                    borderTop="3px dotted"
                    pt="10px"
                  >
                    <Typography
                      fontSize={"12px"}
                      color={"black"}
                      fontWeight={600}
                    >
                      Final Extra Total
                    </Typography>
                    <Box display="flex" alignItems={"center"} gap="10px">
                      <Typography
                        fontSize={"12px"}
                        color={"black"}
                        fontWeight={600}
                      >
                        {formatter.format(
                          Number(tip.extra_Tip) + Number(tip.tax_extra_Tip)
                        )}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              ))
            ) : (
              <Typography textAlign={"center"} color="black">
                No Extra Tips
              </Typography>
            )}
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ExtraTipModal;
